import React from 'react';

const ScaleMarking = ({ position, type, fromEnd = false, getMarkingPosition, scaleY }) => {
  const x = getMarkingPosition(position, fromEnd);

  return (
    <g className="scale-marking">
      <circle
        cx={x} cy={scaleY}
        r={4}
        fill="#EF4444"
        stroke="#DC2626"
        strokeWidth={1}
      />

      <text
        x={x} y={scaleY + 15}
        className="text-xs fill-blue-600 font-medium"
        textAnchor="middle"
        fontSize="10"
      >
        {type.toUpperCase()}
      </text>
      <text
        x={x} y={scaleY + 25}
        className="text-xs fill-blue-600"
        textAnchor="middle"
        fontSize="9"
      >
        {position}mm
      </text>
    </g>
  );
};

export default ScaleMarking;